module.exports = __webpack_public_path__ + "img/wild.4b028bc0.png";